import React from 'react'
import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const StripeFormSubmitButton: React.FC<{
  processing: boolean
  disabled: boolean
  children?: React.ReactNode
}> = ({ processing, disabled, children }): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Button
      disabled={disabled || processing}
      type="submit"
      variant="contained"
      color="primary"
    >
      {processing ? t('checkout.processing') : children}
    </Button>
  )
}
